import { Injectable } from "@angular/core";
import {
  MetaModel,
  WidgetModel,
} from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { FeedbackStudentsPreviewModel } from "common/models/page-models/Feedback students preview/feedback-students-preview-data-model";
import { FeedbackStudentsPreviewMetaModel } from "common/models/page-models/Feedback students preview/feedback-students-preview-form-model";
import { FeedbackStudentFormDataService } from "common/services/data-services/admin/feedback-student/feedback-student-form-data.service";
import {
  SmMetaInputModel,
  SmMetaMultipleChoiceModel,
  SmMetaSelectModel,
  SmMetaTextAreaModel,
} from "common/models/utility-models/meta-model";
import { ROUTE_PATH } from "common/constants/sm-constants";
import { TokenService } from "common/services/core-services/get-token.service";

@Injectable({
  providedIn: "root",
})
export class FeedbackStudentFormWidgetService extends FormWidgetService<FeedbackStudentsPreviewModel> {
  constructor(protected ds: FeedbackStudentFormDataService, private tokenService: TokenService) {
    super(ds);
  }
  getMetaModel(): MetaModel {
    const meta = new FeedbackStudentsPreviewMetaModel();
    return meta.getMetaModel();
  }
  override prepareMetaModel(
    dataModel: any,
    metaModel: FeedbackStudentsPreviewMetaModel,
    routeData: WidgetModel
  ): Promise<FeedbackStudentsPreviewMetaModel> {
    return new Promise<FeedbackStudentsPreviewMetaModel>((resolve, reject) => {
      // Set form title from response
      metaModel['formTitle'] = dataModel.title;
      // console.log(dataModel.title);


      // Extract categories from categorydata, remove duplicates and undefined
      metaModel['categories'] = Array.from(new Set(dataModel.categorydata.map(item => item.category)))
        .filter(item => item !== undefined)
        .map(category => ({ category }))
        // .reverse();

      const tokenDetails = this.tokenService.getDetailsFromToken(localStorage.getItem('token'));

      // Set redirect path based on user role from token
      metaModel.redirectPath =
        tokenDetails?.['tokenData']?.role === 2
          ? ROUTE_PATH.studentFeedbackGrid
          : ROUTE_PATH.feedbackStudentList;
      // console.log(tokenDetails?.['tokenData']?.role);

      const cat = metaModel['categories'].map(item => item.category);

      // Process each question and assign properties based on questionType
      // console.log(dataModel.details, "dataModel.details");

      dataModel.questions.forEach((question) => {
        let options: any[] = [];
        let questionMetaModel;
        // console.log(question.question_type, "question ios");


        switch (question.question_type) {
          case 0:
            // console.log(' case 0');

            metaModel.properties[question.id] = new SmMetaInputModel(
              String(question.id),
              String(question.id),
              "input",
              true,
              "col-12 col-md-6",
              1,
              1,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              200,
              1
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 1:
            let options: any[] = [];
            question.options.forEach((option) => {
              let opt = {
                value: option.option_text,
                id: option.id,
                field_name: option.id,
                label: option.option_text,
              };
              options = [...options, opt];
            });
            // console.log(' case 1', options);

            metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
              String(question.id),
              String(question.id),
              "singleChoice",
              true,
              "col-12 col-md-6",
              1,
              2,
              question.question_text,
              "number",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              options,
              "",
              "id",
              false,
              false,
              false,
              false,
              false,
              false
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 2:
            let yesNoOptions: any[] = [
              {
                value: 1,
                id: `${question.id}_yes`,
                field_name: "Yes",
                label: "Yes",
              },
              {
                value: 0,
                id: `${question.id}_no`,
                field_name: "No",
                label: "No",
              },
            ];
            // console.log(' case 2', yesNoOptions);

            metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
              String(question.id), // Use a unique identifier for yes/no options
              String(question.id), // Use the same identifier for consistency
              "singleChoice",
              true,
              "col-12 col-md-6",
              1,
              2,
              question.question_text,
              "number",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              yesNoOptions,
              "",
              "option_text",
              false,
              false,
              false,
              false,
              false,
              false
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 3:
            // console.log(' case 3');

            metaModel.properties[question.id] = new SmMetaInputModel(
              String(question.id),
              String(question.id),
              "ratings",
              true,
              "col-12 col-md-6",
              1,
              1,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              100,
              1
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 4:
            let dropdownOptions: any[] = [];
            // console.log(' case 4');

            metaModel.properties[question.id] = new SmMetaSelectModel(
              String(question.id),
              String(question.id),
              "select",
              true,
              "col-12 col-md-6 col-lg-6",
              1,
              1,
              question.question_text,
              "select",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              question.options,
              "option_text",
              "option_text"
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;


          case 5:
            metaModel.properties[question.id] = new SmMetaTextAreaModel(
              String(question.id),
              String(question.id),
              "SimpleTextarea",
              true,
              "col-12 col-md-6",
              1,
              1,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              200,
              1,
              false,
              false
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 6:
            let mcqoptions: any[] = [];
            question.options.forEach((option) => {
              let opt = {
                value: option.id,
                id: option.id,
                field_name: option.id,
                label: option.option_text,
              };
              mcqoptions = [...mcqoptions, opt];
            });
            // console.log(mcqoptions);

            metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
              String(question.id),
              String(question.id),
              "multipleChoice",
              true,
              "col-12 col-md-6",
              1,
              2,
              question.question_text,
              "",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              mcqoptions,
              "",
              "",
              true,
              false,
              false,
              false,
              false,
              false
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
              // console.log(metaModel.properties[question.id]["selectedCategory"]);
              // console.log(cat.includes(question.selected_category_text));
              
              
            break;
        }

        // Set selectedCategory if in categories
        if (questionMetaModel) {
          questionMetaModel['selectedCategory'] = cat.includes(question.selected_category)
            ? question.selected_category_text
            : '';
          metaModel.properties[question.id] = questionMetaModel;
        }
      });

      resolve(metaModel);
    });
  }
}
